"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_NAME = exports.CLEAR_LABEL = exports.ADDON_PARAM_KEY = exports.ADDON_ID = void 0;
const ADDON_ID = 'cssVariables';
exports.ADDON_ID = ADDON_ID;
const ADDON_PARAM_KEY = 'cssVariables';
exports.ADDON_PARAM_KEY = ADDON_PARAM_KEY;
const CLEAR_LABEL = 'No Theme';
exports.CLEAR_LABEL = CLEAR_LABEL;
const EVENT_NAME = 'storybookcssvariables:theme:change';
exports.EVENT_NAME = EVENT_NAME;